// TS Adarticle JavaScript functionality

document.addEventListener('DOMContentLoaded', function() {
  // Handle scroll to product functionality for advertorial hero buttons
  const adarticleButtons = document.querySelectorAll('[data-adarticle-product]');
  
  adarticleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Find the ts-main-product section
      const productSection = document.querySelector('ts-main-product');
      
      if (productSection) {
        // Smooth scroll to the product section
        productSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        console.warn('ts-main-product section not found on page');
      }
    });
  });

  // Smooth scroll for internal links
  const internalLinks = document.querySelectorAll('a[href^="#"]');
  internalLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Intersection Observer for animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);

  // Observe feature blocks for animations
  const featureBlocks = document.querySelectorAll('.ts-adarticle-features__feature');
  featureBlocks.forEach(block => {
    observer.observe(block);
  });
});

// Add CSS for animations
const style = document.createElement('style');
style.textContent = `
  .ts-adarticle-features__feature {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  
  .ts-adarticle-features__feature.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
`;
document.head.appendChild(style);



